<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <DownloadReport text="Download Annual Report and Financial Statements 2018/19"/>
    <PageHero>
      <TextHeading variant="subtitle">Morrisons Annual Report</TextHeading>
      <TextHeading variant="xl">
        Broader, stronger
        <br>Online Review of 2018/19
      </TextHeading>
      <BaseButton class="mt-10 text-primary" rounded="full" variant="white" width="small">
        <BaseIcon name="arrow_downward" size="22"></BaseIcon>
      </BaseButton>
    </PageHero>
    <PageGrid>
      <PageMain>
        <PageSection title="Morrisons Corporate Responsibility Stories And Programmes">
          <Cards cols="4">
            <CardsCol>
              <CardDownload title="Chairman's statement" shape="oval"/>
            </CardsCol>
            <CardsCol>
              <CardDownload title="Chief Executive's statement" shape="rectangle"/>
            </CardsCol>
            <CardsCol>
              <CardDownload
                title="Chief Finance and Commercial Officer's statement"
                shape="triangle"
              />
            </CardsCol>
            <CardsCol>
              <CardDownload title="Annual Report 2018/19" shape="triangle"/>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSectionFluid title="Meaningful, sustainable growth: Financial Highlights">
          <StatsBar/>
        </PageSectionFluid>
        <PageSection
          title="111Strategic Highlights"
          subtitle="We are making progress on our six priorities as we continue to listen and learn from our colleagues and customers:"
        >
          <Cards cols="3">
            <CardsCol>
              <CardLink
                title="To be more competitive"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="To be serve customers better"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Find local solutions"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Develop popular and useful services"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="To simplify and speed up the organisation"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="To make core supermarkets strong again"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection
          title="Strategic Highlights"
          subtitle="We are making progress on our six priorities as we continue to listen and learn from our colleagues and customers"
          gradient
        >
          <Cards cols="3">
            <CardsCol>
              <CardLink
                title="To be more competitive"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="To be serve customers better"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Find local solutions"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Develop popular and useful services"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="To simplify and speed up the organisation"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="To make core supermarkets strong again"
                link="See our priorities"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection
          title="Plastic"
          subtitle="Morrisons is becoming more popular and relevant to more people by building a broader, stronger business"
        >
          <MainBanner
            gradient
            header="Reducing unnecessary packaging, using recyclable or recycled material wherever possible."
          />
          <Cards cols="4">
            <CardsCol>
              <CardLink
                title="Nutmeg"
                link="Listening & Responding"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Local solutions"
                link="Campylobacter Update"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Naturally Wonky"
                link="Farming Programme"
                category="Strategic Highlights"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink title="Digital" link="Carrier bag charging" category="Strategic Highlights"></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <PageHighlightArticles
          subtitle="Creating Values"
          title="Our four key stakeholders"
          tabImages
          filter
        ></PageHighlightArticles>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import PageHero from '../components/PageHero.vue'
import PageHighlightArticles from '../components/PageHighlightArticles.vue'
import CardsCol from '../elements/CardsCol.vue'
import MainBanner from '../components/MainBanner.vue'
import PageSectionFluid from '../elements/PageSectionFluid.vue'
import StatsBar from '../components/StatsBar.vue'
import CardDownload from '../components/CardDownload.vue'
import TheFooter from '../components/TheFooter.vue'
import Cards from '../elements/Cards.vue'
import CardLink from '../components/CardLink.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import DownloadReport from '../components/DownloadReport.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'AnnualReport',
  components: {
    TheHeader,
    BreadcrumbBar,
    DownloadReport,
    TextHeading,
    PageGrid,
    PageMain,
    PageSection,
    Cards,
    CardLink,
    TheFooter,
    CardDownload,
    StatsBar,
    PageSectionFluid,
    MainBanner,
    CardsCol,
    PageHero,
    PageHighlightArticles,
    BaseButton,
    BaseIcon
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>